<template>
<div class="chapter">
<div class="inner_page">
<div class="Title_Page">
<h2 class="chaptitle2"><a id="page_14"></a><a href="#/006_Contents#ch2" id="rch2"><b>“Used Cows for Sale”</b></a></h2>
<p class="sub1"><b>Actual signs from roadsides, stores, and restaurants.</b></p>
<p class="image"><img alt="images" src="images/img_p17.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Chapter2.vue?28ddf067